/** Hook to play a score */

import { useAudioEngine } from '@tunasong/audio-ui'
import { EasyScore } from '@tunasong/music-lib'
import type { Rhythm, Score } from '@tunasong/models'
import { useCallback, useRef } from 'react'

export const usePlayScore = (score: Score, rhythm?: Rhythm | null) => {
  const { lang, meter } = score

  const engineRef = useRef(useAudioEngine())
  const play = useCallback(() => {
    const bars: string[] = lang.split('\n')
    /** Set tempo. A score that stores its own meter (GH #1984) plays in it, not in the song's. */
    if (rhythm) {
      engineRef.current.rhythm = meter ? { ...rhythm, meter } : rhythm
    }

    /**
     * Each stave is a bar, and the bars play in sequence. `playSequence` times its events relative
     * to the call, so the bars go in as ONE sequence: a call per bar started every bar at the same
     * moment (GH #1993). Rests and ties are events too, and keep the time.
     */
    engineRef.current.playSequence(bars.flatMap(bar => EasyScore.parseEvents(bar)))
  }, [lang, meter, rhythm])
  return play
}
